/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentFileContent
 */
export interface AttachmentFileContent {
    /**
     * 
     * @type {string}
     * @memberof AttachmentFileContent
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentFileContent
     */
    buffer: object;
}

export function AttachmentFileContentFromJSON(json: any): AttachmentFileContent {
    return AttachmentFileContentFromJSONTyped(json, false);
}

export function AttachmentFileContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentFileContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'buffer': json['buffer'],
    };
}

export function AttachmentFileContentToJSON(value?: AttachmentFileContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'buffer': value.buffer,
    };
}


